export default {"PACKAGE_VERSION": "2.1.153751.0 (00bdd3a5)","UI_THEME": "polaris"}